<template>
    <div class="" style="width:100%">
      <div class="card-box" v-for="item in list">
        <header class="card-name">
          {{item.name}}
        </header>
         <router-link tag="div" :to="{path:child.path,query:{url: child.url}}" v-for="child in item.children" style="text-align:center">
          <card :title="child.name" size="sm" :cardStyle="{cursor: 'pointer' }">
             <div class="" slot="media">
                <img src="../../assets/1.png" style="width: 80%;" alt="" />
             </div>
          </card>
        </router-link>
      </div>
    </div>
</template>

<script>

import card from 'components/card.vue'

export default {
  data() {
    return {
      currentDate: new Date(),
      list:[]
    };
  },
   components:{
    card: card
  },
   methods: {
      request: function(){
         var vm = this
         vm.list = [
           {
              name:'租户管理',
              children:[
                {name:"我的定制信息",path:'/bossTenantInformationImg', url:'http://pre.service.imfbp.com/ifbp-boss-web//bossTenantInformationImg/toBossTenantInformationImgPage?moduleValue=timedtask-infomation-manage&rt=Kc8bBnpsjTxBG7rncyYfppTCSwAX7cHa'}
              ]
            },
              {
              name:'组织管理',
              children:[
                {name:"组织机构管理",path:'/toBossOrgPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossOrg/toBossOrgPage?moduleValue=org_manage&rt=b3CcktMCnCRtZmPmyGDPnbZpHZxPZCAA'},
                {name:"部门管理",path:'/toBossDeptInfoPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossDeptInfo/toBossDeptInfoPage?moduleValue=dept_manage&rt=htPirQWdaX5szztjiFGcGMmQAaJxzk3N'},

                {name:"机构银行",path:'/toBossOrgBankAccPage', url:'http://pre.service.imfbp.com/ifbp-boss-web//bossOrgBankAcc/toBossOrgBankAccPage?moduleValue=bankacc_manage&rt=Zcdd2bHKfZsihRKQsKCc7EaiAwXf6Fdk'},
                {name:"人员档案管理",path:'/toBossPersonnelInformationPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossPersonnelInformation/toBossPersonnelInformationPage?moduleValue=personnelinformation-manage&rt=7mncpy4k6PMsrjRftiCdzrW3Ndsr3jZm'}

              ]
            },
             {
              name:'权限管理',
              children:[
                {name:"用户管理",path:'/toBossUserPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossUser/toBossUserPage?moduleValue=user_manage&rt=AerGANfEDcdFBKx5ykHyKHsaY3GhkGw2'},
                {name:"角色管理",path:'/toBossDeptInfoPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossRole/toBossRolePage?moduleValue=role_manage&rt=nDmeaZD3MFiZDhd46ir545nZBEryJj5F'},

                {name:"角色用户管理",path:'/toBossUserRolePage', url:'http://pre.service.imfbp.com/ifbp-boss-web//bossUserRole/toBossUserRolePage?moduleValue=userrole-manage&rt=ayhTkScG2MycShc8byQpbcMmTR7NTJz7'},
                {name:"密码管理",path:'/toPasswordReset',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossUser/toPasswordReset?moduleValue=password_manage&rt=zeRwGaidYAxATm6NMaScrkFEG7NkcJhE'}

              ]
            },

            {
              name:'基础数据管理',
              children:[
                {name:"参数值管理",path:'/toBossParameterValuePage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossParameterValue/toBossParameterValuePage?moduleValue=parameterValue&rt=hC4QbnrETjZQR4FAJfdK7AK3TBhQwxQw'},
                {name:"币种管理",path:'/toBossCurrencyPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossCurrency/toBossCurrencyPage?moduleValue=currency-manage&rt=dT4Pk7d5k4X25wHmAr4TPSwGeeiNHf8j'},

                {name:"单据项目管理",path:'/toBossConditionItemPage', url:'http://pre.service.imfbp.com/ifbp-boss-web//bossConditionItem/toBossConditionItemPage?moduleValue=condition-manage&rt=DAsPPJNK77MSXBnsx4PtPc3WjiKeQsGB'}
              ]
            },


            {
              name:'预警管理',
              children:[
                {name:"预警规则管理",path:'/toBossTimedTaskPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossTimedTask/toBossTimedTaskPage?moduleValue=timedtask-manage&rt=36E4eCs34ziZ2z8FTDKQ4khcSQF62MRe'},
                {name:"预警用户设置",path:'/toBossTimedTaskUserPage',url:'http://pre.service.imfbp.com/ifbp-boss-web//bossTimedTaskUser/toBossTimedTaskUserPage?moduleValue=timedtask-manage-user&rt=xPDxJfySfShZbc6r3AfwtpDCRfKZBQwa'},

                {name:"预警角色设置",path:'/toBossTimedTaskRolePage', url:'http://pre.service.imfbp.com/ifbp-boss-web//bossTimedTaskRole/toBossTimedTaskRolePage?moduleValue=timedtask-manage-role&rt=FHZKtAE2z48tAsDAMtDJSiFEZbtp7aFn'},
                  {name:"预警日志管理",path:'/toBossTimedTaskLogPage', url:' http://pre.service.imfbp.com/ifbp-boss-web//bossTimedTaskLog/toBossTimedTaskLogPage?moduleValue=timedtask-manage-log&rt=8Wb4YAjziZpX4wBjaJbhhzwkDp4S6wdr'},


              ]
            },
             {
              name:'日志管理',
              children:[
                {name:"登录日志管理",path:'/toBossLoginLogPage', url:'http://pre.service.imfbp.com/ifbp-boss-web//bossLoginLog/toBossLoginLogPage?moduleValue=login_log_manage&rt=j2riJsJtb2Dwt5QThTZMCFF2TjbjwN6G'}
              ]
            }
          ]

      },
      opentab: function(child){
        var path = child.path;
        console.log('path:'+path);
        this.$router.push({path:path,query:{url: child.url}});

      }
    },

    created: function(){
      this.request()
    }
}
</script>

<style>
  /*.card-box{
    margin:50px!important;
    box-shadow: 1.5px 1.5px 2px 2px #ccc;
    padding: 20px 40px 40px 40px;
    border-radius:3px;
  }*/

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 50%;
    display: block;
    margin: 0 auto;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>
 No newline at end of file



// WEBPACK FOOTER //
// index.vue?17ab4880